var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZamzam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9697 28H10.9697C7.96973 28 7.96973 26.65 7.96973 25V24C7.96973 23.45 8.41973 23 8.96973 23H26.9697C27.5197 23 27.9697 23.45 27.9697 24V25C27.9697 26.65 27.9697 28 24.9697 28Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7195 19V23H9.26953V19C9.26953 15.16 11.9795 11.95 15.5895 11.18C16.1295 11.06 16.6895 11 17.2695 11H18.7195C19.2995 11 19.8695 11.06 20.4095 11.18C24.0195 11.96 26.7195 15.16 26.7195 19Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.5C20.5 10.74 20.47 10.96 20.41 11.18C19.87 11.06 19.3 11 18.72 11H17.27C16.69 11 16.13 11.06 15.59 11.18C15.53 10.96 15.5 10.74 15.5 10.5C15.5 9.12 16.62 8 18 8C19.38 8 20.5 9.12 20.5 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZamzam);
export default __webpack_public_path__ + "static/media/zamzam.732f9119841b164aa293107460fc0b17.svg";
export { ForwardRef as ReactComponent };